import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getServices = async (id) => {
    const { data, error } = await supabase
        .from('service_pricing_duration')
        .select(`*, services(*)`)
        .eq("service", id)
        .single()

    if (error) {
        throw new Error(error.message)
    }

    return data
}

export default function useGetAllServicePricingDurationByService(id) {
    return useQuery({
        queryKey: ['useGetAllServicePricingDurationByService',id],
        queryFn: () => getServices(id),
        staleTime: 0,
        enabled: !!id
    })
}
